<template>
  <div class="editSignCode">
    <mt-header :title="title" class="reftitle">
      <mt-button slot="left" icon="back" @click="goback">返回</mt-button>
    </mt-header>
    <div class="editsignpasscont">
      <mt-field label="新密码" placeholder="请输入新密码" @blur.native.capture="validpwd" type="password" v-model="password"></mt-field>
      <mt-field label="确认密码" placeholder="请确认新密码" @blur.native.capture="validpwd2" type="password" v-model="password1"></mt-field>
    </div>
    <div class="editsignpasscont yzmposition">
      <mt-field label="验证码" placeholder="请输入验证码" type="number" v-model="mobileCode"></mt-field>
      <div>
        <button class="fr codebtn" :class="{cliac:flag}" @click="getCode()" v-bind:disabled="flag">{{codeValue}}
        </button>
      </div>
    </div>
    <div class="epbtdiv">
      <mt-button class="login-btn" size="large" type="primary" @click="sure()">保&nbsp;&nbsp;存</mt-button>
    </div>
  </div>
</template>
<script>
  import {Toast} from 'mint-ui';
  export default {
    data () {
      return {
        count: 60,
        codeValue: '获取验证码',
        flag: false,
        outTimer: '',
        mobileType: 6,  // 修改签约密码验证码,
        mobileCode: "",
        oldpassword: "",
        password: "",
        password1: "",
        title: decodeURIComponent(this.$route.query.title)
      }
    },
    methods: {
      goback: function () {
        history.go(-1); //后退1页
      },
      validpwd: function () {
        var sc = this.password;
        var reg = /^\d{6}$/;
        if (sc == "") {
          this.$toast('签署密码不可以为空');
          return false;
        }
  		if (!reg.test(sc)) {
            Toast("签署密码为6位数字.");
            return false;
        }
      },
      validpwd2: function () {
        if(this.password != this.password1){
          this.$toast('两次密码输入不一致');
          return false;
        }
      },
      valiateData: function () {
        if (this.password == "") {
          this.$toast('签署密码不可以为空');
          return false;
        }
        var sc = this.password;
        if (sc.length != 6) {
          Toast("签署密码为6位数字.");
          return false;
        } else {
          var reg = /^\d{6}$/;
          if (!reg.test(sc)) {
            Toast("签署密码为6位数字.");
            return false;
          }
        }
        if(this.password != this.password1){
          this.$toast('两次密码输入不一致');
          return false;
        }
        if (this.mobileCode == "") {
          this.$toast('验证码不可以为空.');
          return false;
        }
        return true;
      },
      sure: function () {

        var flag = this.valiateData();
        if (!flag) {
          return;
        }

        this.$http.post(
          domain("_nextPwdCode"), {
            // mobileType: this.mobileType,
            mobileCode: this.mobileCode,
            password: $.md5(this.password)
          },
          {emulateJSON: true}
          )
          .then(function (response) {
              //接口返回数据
              var code = response.data.code;
              var msg = response.data.msg;
              if (code == "0") {
                let instance = Toast({
                  message: '修改成功'
                });
                setTimeout(function () {
                  instance.close();
                  history.go(-1); //后退1页
                }, 2000);
              } else {
                this.$toast(msg);
              }
            }, function (error) {
              console.log(error)
              //Toast("数据获取响应异常.")
            }
          )
      },
      getCode: function () {
        this.$http.post(
          domain("_getValidateCode"),
          {emulateJSON: true}
          )
          .then(function (response) {  //接口返回数据
            if (response.body.code == '0') {
              this.$toast('验证码已发送,请查收');
              this.settime();
            } else {
              this.$toast('获取验证码失败,请稍后重试');
            }
          }, function (error) {
          })
      }
      ,
      settime: function () {
        var that = this;
        if (this.count == 0) {
          this.count = 60;
          this.flag = false;
          this.codeValue = '获取验证码';
          if (this.outTimer != null) {
            this.outTimer = null;
            return;
          }
        }
        this.flag = true;
        this.count--;
        this.codeValue = "重新发送(" + this.count + "s)";
        this.outTimer = setTimeout(function () {
          that.settime()
        }, 1000);
      }
    },
    components: {}
  }
</script>
<style>
  .editSignCode {
    height: 100%;
    background-color: #f0f0f0;
  }

  .editsignpasscont {
    margin: 15px 0;
  }

  .editsignpasscont .mint-cell-text {
    color: #7d7d7d;
  }

  .epbtdiv {
    padding: 0 10px;
  }

  .editSignCode .mint-cell-wrapper, .editSignCode .mint-cell:last-child {
    background-size: 100% 1px;
  }
  .editpass .mint-cell-title {
    width: 75px;
  }

  .editsignpasscont .codebtn {
    display: block;
    cursor: pointer;
    color: #1f74d8;
    position: absolute;
    z-index: 2;
    width: 95px;
    height: 38px;
    top: 170px;
    left: 100%;
    margin-left: -102px;
    text-align: center;
    border: 0;
    background-color: #ffffff;
  }
  .editSignCode .mint-cell-title{
    width:75px;
  }
</style>



// WEBPACK FOOTER //
// src/module/my/EditSignCode.vue